import Typography from "@mui/material/Typography";
import {Button, Grid2} from "@mui/material";
import React, {useState} from "react";
import EditOpeningHoursModal from "./editOpeningHoursModal/EditOpeningHoursModal";
import useSociety from "../../../../hooks/useSociety";
import {SocietyOpeningHoursDTO} from "../../../../context/SocietyProvider";
import IconButton from "@mui/material/IconButton";
import Edit from "@mui/icons-material/Edit";

interface OpeninHoursProps {
    openingHours: SocietyOpeningHoursDTO;
}

const OpeningHours = ({openingHours}: OpeninHoursProps) => {

    const [openEditModal, setOpenEditModal] = useState<boolean>(false);

    const {society} = useSociety();

    return (
        <Grid2 container size={12} textAlign={{xs: "center", md: "left"}}>

            <Typography
                width={"100%"}
                sx={{
                    color: '#ffffff',
                    fontSize: {xs: 22, sm: 24, md: 26},
                }}
                variant={"firstVariant"}
            >
                Horaires
            </Typography>

            {openingHours.daysOpen.some(dayOpen => dayOpen) && (
                <Grid2 container size={12} mt={2} spacing={1}>
                    {openingHours.daysOpen.map((isOpen, index) => {
                        const days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

                        return (
                            <Grid2 key={index} size={12}>
                                <Typography
                                    sx={{
                                        fontSize: {xs: 16, sm: 18, md: 20},
                                    }}
                                    variant={"fourthVariant"}
                                >
                                    {days[index]}: {
                                    isOpen
                                        ? `${openingHours.openingTimes[index]} - ${openingHours.closingTimes[index]}`
                                        : 'Fermé'
                                }
                                </Typography>
                            </Grid2>
                        );
                    })}
                </Grid2>
            )}

            {society.secured && (
                <Grid2 size={12} mt={1}>

                    <IconButton
                        aria-label="Instagram"
                        variant="secondVariant"
                        onClick={() => {
                            setOpenEditModal(true)
                        }}
                    >
                        <Edit/>
                    </IconButton>
                </Grid2>
            )}

            <EditOpeningHoursModal open={openEditModal} setOpen={setOpenEditModal} openingHours={openingHours}/>

        </Grid2>
    );
}

export default OpeningHours
